module.exports = __webpack_public_path__ + "static/media/fecha.88c61c63.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/RateCall/fecha.svg
// module id = 1828
// module chunks = 0